export let attributeLabel = {
	computed: {
		isRequired: function () {
			let itemValidationRules = this.$store.getters.getItemValidationRules
			let that = this
			let required = false

			for (let i = 0; i < itemValidationRules.length; i++) {
				for (let j = 0; j < itemValidationRules[i].required.length; j++) {
					if (that.lang && itemValidationRules[i].required[j].attribute === that.attributeName && itemValidationRules[i].required[j].language === that.lang) {
						required = true
					}
					if (that.lang && itemValidationRules[i].required[j].attribute === that.attributeName && !itemValidationRules[i].required[j].language) {
						required = true
					}
					if (!that.lang && itemValidationRules[i].required[j].attribute === that.attributeName) {
						required = true
					}
				}
			}

			return required
		},
		requiredLabel: function () {
			return this.isRequired ? 'required-label': ''
		},
		requiredLabelIcon: function () {
			return this.isRequired ? 'required': ''
		},
		requiredPrimaryIcon: function () {
			return this.isPrimary ? 'primary': ''
		}
	}
}
